// Column indexes for values
export const V1 = "v1";
export const V2 = "v2";
export const V3 = "v3";
export const V4 = "v4";
